import React from "react";
import { GamesListBox } from "../../containers";

export const GamesPage = () => {
  return (
    <div>
      <GamesListBox />
    </div>
  );
};
